import { Button } from "antd";
import { useGetCommissionGroupQuery } from "api/TenantSlug/CommissionGroup/hooks.ts";
import { CommissionGroupEditForm } from "components/Forms/CommissionGroupEditForm/CommissionGroupEditForm.tsx";
import { userGroup } from "components/Tables/CommissionGroupTable/temp";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";
import { getDrawerSearchParams } from "utils/drawerHelpers";

import CommissionGroupData = App.Data.CommissionGroupData;
interface EditCommissionGroupDrawerProps {
    commissionGroupId: string;
    onSubmit?: () => void;
    setLocalCommissions?: (callback: (prev: CommissionGroupData[]) => CommissionGroupData[]) => void;
}

export const EditCommissionGroupDrawer: FC<EditCommissionGroupDrawerProps> = ({
    commissionGroupId,
    onSubmit,
    setLocalCommissions,
}) => {
    const { t } = usePaldockTranslation("drawers.commission-group-edit");
    const { t: tC } = usePaldockTranslation("common");
    const id = DrawerId.EditCommissionGroup;
    const formId = FormId.CommissionGroupEditForm;

    const drawerUtils = useDrawer();
    const getCommissionGroupQuery = useGetCommissionGroupQuery(
        commissionGroupId,
        {},
        {
            enabled: commissionGroupId !== userGroup.id,
        }
    );

    const handleSubmit = () => {
        getCommissionGroupQuery.refetch();
        onSubmit?.();
        drawerUtils.hide(id, getDrawerSearchParams(id, "id"));
    };

    let commissionGroup = getCommissionGroupQuery.data?.commissionGroup;

    if (commissionGroupId === userGroup.id) {
        commissionGroup = userGroup;
    }

    if (!commissionGroup) {
        return <></>;
    }

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} subTitles={[commissionGroupId]} />}
            searchParamsToClean={getDrawerSearchParams(id, "id")}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={formId}>
                    {tC("save")}
                </Button>
            }
        >
            <CommissionGroupEditForm
                formId={formId}
                onSubmit={handleSubmit}
                commissionGroup={commissionGroup}
                setLocalCommissions={setLocalCommissions}
            />
        </Drawer>
    );
};
